import React from "react";
import Table from "react-bootstrap/Table";
const SideTable = ({ data, cell, headers, side_table_name }) => {
  return (
    <Table size="sm" className="side-table">
      <tbody>
        {headers.map((item, index) => {
          return (
            <tr key={index}>
              <th style={{ width: "30%" }}>
                {data.table.table_body[side_table_name][item]}
              </th>
              <td>
                {item === "creation_date"
                  ? cell.value[item].split("T")[0]
                  : cell.value[item]}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default SideTable;
